import { Howl } from 'howler';
import sfxData from '../../../sfx/64/sfx.json';
const bundledUrl = '/';

const spriteSFX = Object.keys(sfxData.spritemap).reduce((acc, key) => {
  if (key !== 'silence') {
    const { start, end } = sfxData.spritemap[key];
    acc[key] = [start * 1000, end * 1000 - start * 1000];
    console.log('SFX key:', key, 'start:', start, 'end:', end);
  }
  return acc;
}, {});

export const createHowlerIntroVO = (howlerData, handleVoEnd) => {
  const { src, sprite } = howlerData;
  return new Howl({
    preload: true,
    src,
    autoplay: false,
    loop: false,
    volume: 0.5,
    pool: 1,
    sprite,
    onend: function (id) {
      handleVoEnd(id);
    },
  });
};

const getSrc = (pth) => {
  return [`${pth}.mp3`];
};

export const createHowlerIntroMusic = () => {
  return new Howl({
    preload: true,
    src: getSrc(`${bundledUrl}intro/music/music`),
    autoplay: false,
    loop: true,
    volume: 1,
  });
};

export const createHowlerIntroSFX = () => {
  return new Howl({
    preload: true,
    src: getSrc(`${bundledUrl}intro/sfx/64/sfx`),
    autoplay: false,
    loop: false,
    volume: 0.3,
    sprite: introSpriteSFX,
  });
};

const createHowlerSFX = () => {
  return new Howl({
    preload: true,
    src: getSrc(`${bundledUrl}sfx/64/sfx`),
    autoplay: false,
    loop: false,
    volume: 0.5,
    pool: 3,
    sprite: spriteSFX,
  });
};

let howlerSFX = null;
export const getHowlerSFX = () => {
  if (!howlerSFX) {
    howlerSFX = createHowlerSFX();
  }
  return howlerSFX;
};

export const howlerSFXPlayer = {
  play: function (key, vol = 0.5) {
    if (key) {
      const h = getHowlerSFX();
      const id = h.play(key);
      h.volume(vol, id);
    }
  },
};
